import coreDataForm from './coreData/coreDataForm';
import stayDataForm from './data/stayDataForm';
import healthDataForm from './data/healthDataForm';
import apartmentSearchDataForm from './data/apartmentSearchDataForm';
import moveInForm from './data/moveInForm';
import moveInChecklistForm from './data/moveInChecklistForm';
import moveOutForm from './data/moveOutForm';
import moveOutChecklistForm from './data/moveOutChecklistForm';
import financingDataForm from './financialData/financingDataForm';
import allowanceDataForm from './financialData/allowanceDataForm';
import bankAccountDataForm from './financialData/bankAccountDataForm';
import womensShelterFinancesDataForm from './financialData/womensShelterFinancesDataForm';
import workDataForm from './financialData/workDataForm';
import riskForm from './riskData/riskForm';
import propertyManagementMoveInForm from './propertyManagementData/moveInForm';
import propertyManagementMoveOutForm from './propertyManagementData/moveInForm';
import childForm from './childData/childForm';
import type { TabForm } from '../../../common/types/form';
import type { Setting } from '../../../common/types/settings';
import type { Client } from '../../../common/types/client';

const clientForms = (advisors: Setting[]): TabForm<Client>[] => {
  return [
    {
      key: 'clientCoreDataForms',
      title: 'Stammdaten',
      forms: [coreDataForm(advisors)],
    },
    {
      key: 'clientDataCollectionForms',
      title: 'Datenerhebung',
      forms: [
        stayDataForm,
        healthDataForm,
        apartmentSearchDataForm,
        moveInForm(advisors),
        moveInChecklistForm,
        moveOutForm,
        moveOutChecklistForm,
      ],
    },
    {
      key: 'clientDocuForms',
      title: 'Doku',
      forms: [],
    },
    {
      key: 'clientWorkForms',
      title: 'Arbeit / Finanzen',
      forms: [financingDataForm, allowanceDataForm, bankAccountDataForm, womensShelterFinancesDataForm, workDataForm],
    },
    {
      key: 'clientRiskForms',
      title: 'Gefährdung',
      forms: [riskForm],
    },
    {
      key: 'clientChildrenForms',
      title: 'Kinder',
      forms: [childForm(advisors)],
    },
    {
      key: 'clientPropertyManagementForms',
      title: 'Hausmanagement',
      forms: [propertyManagementMoveInForm, propertyManagementMoveOutForm],
    },
  ];
};

export default clientForms;
